import React, { useReducer /* , useEffect */ } from 'react'
import { emailVerificationInitialState } from './store/State'
import emailVerificationReducer from './store/Reducer'

import EmailVerificationService from './Service'
import IUserData from 'types/sign-in/IUserData'

import { IEmailVerificationProps } from './interface'
// import { navigate } from '@reach/router'

import { /* useServiceState, */ useNotification } from 'helpers'
import SessionManagerService from 'smart-components/session-manager/Service'

const emailVerificationContext = {
  state: emailVerificationInitialState,
  handlers: {
    resendEmail: () => new Promise<void>(() => {})
  }
}

export type EmailVerificationContext = typeof emailVerificationContext

export const EmailVerificationContextProvider = React.createContext<EmailVerificationContext>(emailVerificationContext)

const Provider: React.FC<IEmailVerificationProps> = ({ /* routeId, */ children }) => {
  const [state, dispatch] = useReducer(emailVerificationReducer, emailVerificationInitialState)
  // const sessionState = useServiceState(SessionManagerService, false)
  const { emitSuccess, emitError } = useNotification()

  const onResendEmailSuccess = (userData: IUserData) => {
    SessionManagerService.setCurrentUser(userData)
    emitSuccess('Email verification sent')
  }

  const handlers = {
    resendEmail: EmailVerificationService.resendEmail(state, dispatch, onResendEmailSuccess, emitError)
  }

  const contextValue = {
    ...emailVerificationContext,
    state,
    handlers
  }

  // useEffect(() => {
  //   const { currentUser } = sessionState
  //   if (currentUser && currentUser.isVerified) {
  //     const [redirect, path] = WithRequireAuthenticationService.decideNextRoute(currentUser, routeId, '/top-fives')

  //     if (redirect) {
  //       navigate(path)
  //     }
  //   }
  // }, [sessionState, routeId])

  return (
    <EmailVerificationContextProvider.Provider value={contextValue}>
      {children}
    </EmailVerificationContextProvider.Provider>
  )
}

export default Provider
